import React, { Component } from "react";
import { isInteractiveKeyCode } from "../../utils/helpers";

class SearchButtons extends Component {
  constructor(props) {
    super(props);
  }

  handleKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      this.props.onClickMethod;
    }
  }

  render() {
    return (
      <button
        id={this.props.buttonId}
        className={`btn ${this.props.buttonClassList}`}
        onClick={this.props.onClickMethod}
        onKeyUp={(e) =>this.handleKeyUp(e)}
        disabled={this.props.resetFiltersDisabled}
        tabIndex="0"
      >
        {this.props.buttonText}
      </button>
    );
  }
}
export default SearchButtons;
